<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="600px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Add Tax') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 pa-2 ma-2 white>
              Income Before Tax: <strong>{{ income.income_before_tax | currency }}</strong>
            </v-flex>
            <v-flex xs12 pa-2 ma-2 white>
              Tax Percentage: <strong>{{ income.tax_percentage }}%</strong>
            </v-flex>
            <v-flex xs12 pa-2 ma-2 white>
              Due Tax Amount: <strong>{{ income.due_tax_amount | currency }}</strong>
            </v-flex>
            <v-flex xs8 pa-2>
              <v-text-field
                id="expense-focus-me"
                v-model="form.tax_amount"
                :label="`${$t('Tax Amount')} (${systemCurrency}) *`"
                box
                hide-details
                background-color="white"
                :error="errors.has('tax_amount')"
                name="tax_amount"
                v-validate="'required|decimal:3|min_value:0'"
                data-vv-delay="1000"
              />
            </v-flex>

            <v-flex xs4 pa-2>
              <v-menu v-model="taxDateMenu" full-width max-width="290" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :value="form.tax_date"
                  :label="`${$t('Tax Date')} *`"
                  prepend-inner-icon="event"
                  box
                  readonly
                  hide-details
                  name="tax_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('tax_date')"
                  v-validate="'required|date_format:yyyy-MM-dd'"
                />
                <v-date-picker @change="taxDateMenu = false" v-model="form.tax_date" />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnAddLoading: false,
      form: {
        tax_date: '',
        tax_amount: 0
      },
      taxDateMenu: false,
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      income: 'taxes/getIncome'
    })
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addTax: 'taxes/addTax'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.form.tax_date = this.$moment()
        .format()
        .substr(0, 10)
      this.form.tax_amount = this.income.due_tax_amount

      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('expense-focus-me').focus()
      })
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnAddLoading = true
          let formData = new FormData(event.target)
          formData.append('net_income_before_tax', this.income.income_before_tax)

          this.addTax(formData)
            .then(() => {
              this.btnAddLoading = false
              this.$emit('reset-datatable')
              if (this.keepForm) {
                this.resetForm()
              } else {
                this.$emit('hidemodal')
              }
            })
            .catch(() => {
              this.btnAddLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
